import React, { Component } from 'react';
import './styles.css';

class BodyHeader extends Component {
	render() {
		return (
			<div className="results-document-layout-body-header">
				{this.props.children}
			</div>
		);
	}
}

export default BodyHeader;
